import React from "react";
import { useAuth } from "../contexts/AuthContext";
import PlayerDashboard from "./PlayerDashboard";
import ScoutDashboard from "./ScoutDashboard";
import CoachDashboard from "./CoachDashboard";
import AdminDashboard from "./AdminDashboard";

export default function DashboardRouter() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "player") return <PlayerDashboard />;
  if (user.role === "scout") return <ScoutDashboard />;
  if (user.role === "coach") return <CoachDashboard />;
  if (user.role === "admin") return <AdminDashboard />;
  return <div className="p-8 text-white">Unknown role</div>;
}
